import { NewsAO } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const sentNewsAOReducer: RemoteReducer<NewsAO[]> =
  createRemoteReducer("sentNewsAO")
